export default __webpack_public_path__ + "static/media/img-11.483500d7.jpg";